import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Button from '../../Button';
import { Types as ButtonTypes } from '../../Button/Button';
import LabledInput from '../../LabledInput';

const LinkForm = React.memo(props => {
  const { onClose, onSubmit, defaultUrl } = props;
  const [url, setUrl] = useState(defaultUrl);

  const handleSubmit = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();

      onSubmit({
        url,
      });
      onClose();
    },
    [url]
  );

  const handleChangeUrl = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    event.persist();

    setUrl(event.target.value);
  }, []);

  const handleOnClose = useCallback(event => {
    event.stopPropagation();
    event.preventDefault();

    onClose();
  });

  return (
    <StyledForm onSubmit={handleSubmit}>
      <StyledTitle>Добавить ссылку</StyledTitle>
      <StyledFields>
        <StyledLabeledInput
          required
          label="Ссылка"
          name="href"
          placeholder="URL"
          onChange={handleChangeUrl}
          value={url}
        />
      </StyledFields>
      <StyledControls>
        <StyledButton
          onClick={event => event.stopPropagation()}
          type={ButtonTypes.SUBMIT}
        >
          Добавить
        </StyledButton>
        <StyledCancelButton onClick={handleOnClose}>Отмена</StyledCancelButton>
      </StyledControls>
    </StyledForm>
  );
});

LinkForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  defaultUrl: PropTypes.string,
};

LinkForm.defaultProps = {
  defaultUrl: '',
};

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: white;
  border-radius: 6px;
  width: 670px;
`;

export const StyledTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
`;

const StyledFields = styled.div`
  margin: 17px 0 20px 0;
`;

const StyledControls = styled.div`
  display: flex;
`;

const StyledButton = styled(Button)`
  border-radius: 4px;
  color: white;
  background-color: #007aff;
  font-size: 14px;
  height: 42px;
  line-height: 24px;
  min-height: 25px;
  min-width: 25px;
  padding: 0;
  position: relative;
  text-align: center;
`;

const StyledCancelButton = styled(Button)`
  border: none;
  border-radius: 4px;
  color: #4d4d4d;
  background-color: transparent;
  font-weight: normal;
  font-size: 14px;
  height: 42px;
  line-height: 24px;
  min-height: 25px;
  min-width: 25px;
  padding: 0;
  position: relative;
  text-align: center;
`;

export const StyledLabeledInput = styled(LabledInput)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }

  div {
    min-width: 104px;
    max-width: 104px;
    margin-right: 3px;
    font-size: 14px;
    color: #17181a;
    text-transform: initial;
  }
`;

export default LinkForm;
